import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, getCurrentInstance } from 'vue';
const tagSpacing = 4;
export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollPane',
  setup(__props, {
    expose: __expose
  }) {
    const _this = getCurrentInstance();
    const scrollContainerRef = ref(null);
    // 标签间隔，单位 px
    function handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const scrollContainer = scrollContainerRef.value;
      const scrollWrapper = scrollContainer?.wrapRef;
      scrollWrapper.scrollLeft = scrollWrapper.scrollLeft + eventDelta / 4;
    }
    function moveToTarget(currentTag) {
      const scrollContainer = scrollContainerRef.value;
      const container = scrollContainer?.$el;
      const containerWidth = container.offsetWidth;
      const scrollWrapper = scrollContainer?.wrapRef;
      const tagList = _this?.parent?.exposed?.tags.value || [];
      let firstTag = null;
      let lastTag = null;
      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0];
        lastTag = tagList[tagList.length - 1];
      }
      //   if (firstTag === currentTag) {
      //     scrollWrapper.scrollLeft = 0
      //   } else if (lastTag === currentTag && scrollWrapper) {
      //     scrollWrapper.scrollLeft = scrollWrapper.scrollWidth - containerWidth
      //   } else {
      //     // find preTag and nextTag
      //     const currentIndex = tagList.findIndex(item => item === currentTag)
      //     const prevTag = tagList[currentIndex - 1]
      //     const nextTag = tagList[currentIndex + 1]
      //     // the tag's offsetLeft after of nextTag
      //     const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagSpacing
      //     // the tag's offsetLeft before of prevTag
      //     const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagSpacing
      //     if (afterNextTagOffsetLeft > scrollWrapper.scrollLeft + containerWidth) {
      //       scrollWrapper.scrollLeft = afterNextTagOffsetLeft - containerWidth
      //     } else if (beforePrevTagOffsetLeft < scrollWrapper.scrollLeft) {
      //       scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
      //     }
      //   }
    }
    __expose({
      moveToTarget
    });
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createBlock(_component_el_scrollbar, {
        ref_key: "scrollContainerRef",
        ref: scrollContainerRef,
        vertical: false,
        class: "scroll-container",
        onWheelPassive: handleScroll
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 512);
    };
  }
});